import grpcClient from '~/grpc/grpc-client'
import { commonMetaData } from '@/store/_helpers/common-helper'
import { UpdateIntroductionRequest } from '@/stub/apigateway/profile/introduction_pb'
import { GetMyIntroductionRequest } from '@/stub/apigateway/profile/introduction_pb'
import { IntroductionService } from '@/stub/apigateway/profile/introduction_pb_service'
import { GetMyServicesRequest } from '@/stub/apigateway/profile/service_pb'
import { ServiceService } from '@/stub/apigateway/profile/service_pb_service'
import { GetMyPortfoliosRequest } from '@/stub/apigateway/profile/portfolio_pb'
import { PortfolioService } from '@/stub/apigateway/profile/portfolio_pb_service'
import { GetMyRatingCommentsRequest } from '@/stub/apigateway/profile/rating_pb'
import { RatingService } from '@/stub/apigateway/profile/rating_pb_service'

// initial state
const initialState = () => ({
  introduction: {
    catchphrase: ''
  },
  servicesList: [],
  userSpecialtiesList: [],
  skillsList: [],
  licensesList: [],
  portfoliosList: [],
  careersList: [],
  awardsList: [],
  ratingCommentsList: []
})

// state
export const state = () => initialState()

// getters
export const getters = {}

// actions
export const actions = {
  async fetchMyHome({ commit, rootState }) {
    const [
      { UserSpecialtyService },
      { GetMyUserSpecialtiesRequest },
      { SkillService },
      { GetMySkillsRequest },
      { LicenseService },
      { GetMyLicensesRequest },
      { CareerService },
      { GetMyCareersRequest },
      { AwardService },
      { GetMyAwardsRequest }
    ] = await Promise.all([
      import('~/stub/apigateway/profile/user_specialty_pb_service'),
      import('~/stub/apigateway/profile/user_specialty_pb'),
      import('~/stub/apigateway/profile/skill_pb_service'),
      import('~/stub/apigateway/profile/skill_pb'),
      import('~/stub/apigateway/profile/license_pb_service'),
      import('~/stub/apigateway/profile/license_pb'),
      import('~/stub/apigateway/profile/career_pb_service'),
      import('~/stub/apigateway/profile/career_pb'),
      import('~/stub/apigateway/profile/award_pb_service'),
      import('~/stub/apigateway/profile/award_pb')
    ])

    const metadata = commonMetaData(rootState)
    const grpcClientContextList = [
      {
        method: IntroductionService.GetMyIntroduction,
        request: new GetMyIntroductionRequest(),
        metadata
      },
      {
        method: ServiceService.GetMyServices,
        request: new GetMyServicesRequest(),
        metadata
      },
      {
        method: UserSpecialtyService.GetMyUserSpecialties,
        request: new GetMyUserSpecialtiesRequest(),
        metadata
      },
      {
        method: SkillService.GetMySkills,
        request: new GetMySkillsRequest(),
        metadata
      },
      {
        method: LicenseService.GetMyLicenses,
        request: new GetMyLicensesRequest(),
        metadata
      },
      {
        method: PortfolioService.GetMyPortfolios,
        request: new GetMyPortfoliosRequest(),
        metadata
      },
      {
        method: CareerService.GetMyCareers,
        request: new GetMyCareersRequest(),
        metadata
      },
      {
        method: AwardService.GetMyAwards,
        request: new GetMyAwardsRequest(),
        metadata
      },
      (() => {
        const request = new GetMyRatingCommentsRequest()
        request.setPage(1)
        request.setLimit(3)
        return {
          method: RatingService.GetMyRatingComments,
          request,
          metadata
        }
      })()
    ]
    await Promise.all(
      grpcClientContextList.map(context => {
        return grpcClient(context).then(reply => commit('RECEIVE_HOME', reply))
      })
    )
  },
  async updateIntroduction({ dispatch, rootState }, { params }) {
    const metadata = commonMetaData(rootState)
    const request = new UpdateIntroductionRequest()
    request.setCatchphrase(params.catchphrase)
    await grpcClient({
      method: IntroductionService.UpdateIntroduction,
      request,
      metadata
    })
    await dispatch('fetchMyHome')
  }
}

// mutations
export const mutations = {
  RECEIVE_HOME(state, data) {
    Object.assign(state, data)
  }
}
